import rawSoftwarePlans from "./softwarePlans.json";

export interface SoftwarePlan {
  name: string;
  price: number;
  priceLabel: string;
  period: string;
  audience: string;
  desc: string;
  features: string[];
  included: boolean;
  popular: boolean;
  llmsDescription: string;
}

export const SOFTWARE_PLANS: readonly SoftwarePlan[] = rawSoftwarePlans;

export interface SoftwareOffer {
  "@type": "Offer";
  name: string;
  price: string;
  priceCurrency: "USD";
  priceValidUntil: string;
  priceSpecification: {
    "@type": "UnitPriceSpecification";
    billingPeriod?: "P1M";
  };
}

export function buildSoftwareApplicationOffers(priceValidUntil: string): SoftwareOffer[] {
  return SOFTWARE_PLANS.map((plan) => ({
    "@type": "Offer",
    name: plan.name,
    price: String(plan.price),
    priceCurrency: "USD",
    priceValidUntil,
    priceSpecification: {
      "@type": "UnitPriceSpecification",
      ...(plan.included ? {} : { billingPeriod: "P1M" as const }),
    },
  }));
}

export function formatSoftwarePlanPrice(plan: SoftwarePlan): string {
  return plan.period.startsWith("/") ? `${plan.priceLabel}${plan.period}` : `${plan.priceLabel} ${plan.period}`;
}